import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box } from "@mui/material";
import { FlexProps } from "@/components/Flex";
import Text from "@/components/Text";
import {
  CHART_DIMENSIONS,
  CHART_TYPOGRAPHY,
} from "@/components/app/provider/patient/chart";
import { Action } from "@/dummy-data/appointment-list-data-scheduling";
import {
  BLUE_ACCENT_COLORS,
  GRAY_ACCENT_COLORS,
  GREEN_ACCENT_COLORS,
  LIGHT_GREEN_ACCENT_COLORS,
  ORANGE_ACCENT_COLORS,
  PURPLE_ACCENT_COLORS,
  RED_ACCENT_COLORS,
  YELLOW_ACCENT_COLORS,
} from "@/utils/utils";

export const COLOR_MAPPER: Record<Action, { color: string; bgColor: string }> =
  {
    "Signed Off": {
      color: LIGHT_GREEN_ACCENT_COLORS.textColor,
      bgColor: LIGHT_GREEN_ACCENT_COLORS.backgroundColor,
    },
    "Checked In": {
      color: PURPLE_ACCENT_COLORS.textColor,
      bgColor: PURPLE_ACCENT_COLORS.backgroundColor,
    },
    Confirmed: {
      color: GREEN_ACCENT_COLORS.textColor,
      bgColor: GREEN_ACCENT_COLORS.backgroundColor,
    },
    "In Exam": {
      color: ORANGE_ACCENT_COLORS.textColor,
      bgColor: ORANGE_ACCENT_COLORS.backgroundColor,
    },
    Scheduled: {
      color: BLUE_ACCENT_COLORS.textColor,
      bgColor: BLUE_ACCENT_COLORS.backgroundColor,
    },
    Canceled: {
      color: RED_ACCENT_COLORS.textColor,
      bgColor: RED_ACCENT_COLORS.backgroundColor,
    },
    "No Show": {
      color: GRAY_ACCENT_COLORS.textColor,
      bgColor: GRAY_ACCENT_COLORS.backgroundColor,
    },
    Instant: {
      color: YELLOW_ACCENT_COLORS.textColor,
      bgColor: YELLOW_ACCENT_COLORS.backgroundColor,
    },
    "Doc Pending": {
      color: YELLOW_ACCENT_COLORS.textColor,
      bgColor: YELLOW_ACCENT_COLORS.backgroundColor,
    },
  };

export type AppointmentActionButtonProps = {
  label: Action;
  onClick: (label: Action) => void;
} & FlexProps;

/** Status chip-button of the appointments Action column. */
const AppointmentActionButton = ({
  label,
  onClick,
  ...others
}: AppointmentActionButtonProps) => {
  return (
    <Box
      sx={{
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          opacity: 0.85,
          transform: "scale(1.02)",
        },
        display: "flex",
        alignItems: "center",
        bgcolor: COLOR_MAPPER[label]?.bgColor,
        borderRadius: "5px",
        overflow: "hidden",
        width: others.width || "110px",
        height: others.height || "26px",
        ...others.sx,
      }}
      onClick={(e) => {
        e.stopPropagation();
        onClick(label);
      }}
    >
      <Text
        fontSize={CHART_TYPOGRAPHY.body5.fontSize}
        c={COLOR_MAPPER[label]?.color}
        sx={{
          flex: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          pl: 1,
        }}
      >
        {label}
      </Text>
      <Box
        sx={{
          width: "26px",
          minWidth: "26px",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: COLOR_MAPPER[label]?.color,
        }}
      >
        <ChevronRightIcon
          sx={{ color: "white", fontSize: CHART_DIMENSIONS.iconMd }}
        />
      </Box>
    </Box>
  );
};

export default AppointmentActionButton;
